
import SEO from '../../components/common/seo/SEO'
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage'
import catiaCaaCourse from '../../data/cad_section/catiaCaaCourse'

function CatiaCAACoursePage() {
  return (

    <>

    <SEO
        title="CATIA CAA Customization & Automation Training | CATIA CAA Course | FeesWorth"

        description="Learn CATIA CAA customization and automation with practical training. Master CATIA CAA, CAA RADE, CATIA automation, custom applications, and CAD customization projects with expert training at FeesWorth."

        keywords="CATIA CAA Training, CATIA CAA Customization Training, CATIA CAA Automation, CATIA CAA Course, CATIA CAA RADE Training, CATIA Automation Training, CATIA Customization Course, CATIA CAA Development, CATIA Programming, CATIA Automation Course"

        canonical="https://feesworth.com/catia-caa-customization-automation-training"
      />
      <CourseLandingPage course={catiaCaaCourse} />

    </>
  )
}

export default CatiaCAACoursePage